module.exports = __webpack_public_path__ + "static/media/lincoln-plus.787e245b.svg";